import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { map, share } from "rxjs/operators";
import { EdpResponse, EdpResponseBody } from "@edp-models/response.model";
import { ISimulate } from "@edp-models/conta-certa.model";
import { environment } from "@edp-environments/environment";
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class ContaCertaService {
    private cache: ISimulate[] = [];

    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

    public simulate(body: any): Observable<ISimulate> {
        if (this.cache[body.args.contract_id]) {
            return of(this.cache[body.args.contract_id]);
        }

        return this.http.post(`${environment.apiUrl}contract.simulateCC`, body).pipe(
            map((response: EdpResponse) => {
                const simulation: ISimulate = {
                    success: false,
                };

                if (response.Body.Success && response.Body.Result.Collection.length) {
                    simulation.minimum = parseFloat(response.Body.Result.Collection[0].minimumLimit);
                    simulation.maximum = parseFloat(response.Body.Result.Collection[0].maximumLimit);
                    simulation.amount = parseFloat(response.Body.Result.Collection[0].totalAmount);
                    simulation.success = true;
                    this.cache[body.args.contract_id] = simulation;
                }

                return simulation;
            }),
            share()
        );
    }

    public updateContaCertaValue(args?: any): Observable<Error | EdpResponseBody> {
        return this.apiService.callServicePost("invoice.updateBudgetBilling", args);
    }

}
